module.exports = __webpack_public_path__ + "img/vn.d988aba8.svg";